/* eslint-disable */
import UilCheckCircle from '@iconscout/react-unicons/icons/uil-check-circle';
import UilEdit from '@iconscout/react-unicons/icons/uil-edit';
import UilView from '@iconscout/react-unicons/icons/uil-eye';
import UilFileBookmarkAlt from '@iconscout/react-unicons/icons/uil-file-bookmark-alt';
import UilFileQuestionAlt from '@iconscout/react-unicons/icons/uil-file-question-alt';
import UilInvocie from '@iconscout/react-unicons/icons/uil-invoice';
import UilListUl from '@iconscout/react-unicons/icons/uil-list-ul';
import UilInvoice from '@iconscout/react-unicons/icons/uil-invoice';
import { Tag, Tooltip } from 'antd';
import moment from "moment";
import { AppRoutes } from '../../routes/routes';
import UilUpload from '@iconscout/react-unicons/icons/uil-upload';

export const liveJobTabs = [
    // 0
    {
        to: `${AppRoutes.liveJobs}/query`,
        icon: <UilFileQuestionAlt className="w-[16px] h-[16px] text-light dark:text-white60" />,
        title: "Query",
        statsKey: "query"
    },
    // 1
    {
        to: `${AppRoutes.liveJobs}/quoted`,
        icon: <UilInvocie className="w-[16px] h-[16px] text-light dark:text-white60" />,
        title: "Quoted",
        statsKey: "quoted"
    },
    // 2
    {
        to: `${AppRoutes.liveJobs}/orderConfirmed`,
        icon: <UilFileBookmarkAlt className="w-[16px] h-[16px] text-light dark:text-white60" />,
        title: "Order Confirmed",
        statsKey: "orderConfirmed"
    },
    // 3
    {
        to: `${AppRoutes.liveJobs}/magneticCompassCalibration`,
        icon: <UilFileBookmarkAlt className="w-[16px] h-[16px] text-light dark:text-white60" />,
        title: "Magnetic Compass Calibration",
        statsKey: "magneticCompassCalibration"
    },
    // 4
    {
        to: `${AppRoutes.liveJobs}/jobCompleted`,
        icon: <UilCheckCircle className="w-[16px] h-[16px] text-light dark:text-white60" />,
        title: "Job Completed",
        statsKey: "jobCompleted"
    },
    // 5
    {
        to: `${AppRoutes.liveJobs}/invoiceSent`,
        icon: <UilInvoice className="w-[16px] h-[16px] text-light dark:text-white60" />,
        title: "Invoice Sent",
        statsKey: "invoiceSent"
    },
    // 6
    {
        to: `${AppRoutes.liveJobs}/logistics`,
        icon: <UilInvoice className="w-[16px] h-[16px] text-light dark:text-white60" />,
        title: "Logistics",
        statsKey: "logistics"
    },
    // 7
    {
        to: `${AppRoutes.liveJobs}/all`,
        icon: <UilListUl className="w-[16px] h-[16px] text-light dark:text-white60" />,
        title: "All Live Jobs",
        statsKey: "liveJobs"
    },
]

export const liveJobsColumn = (variant, roleId) => {
    let defaultColumn = [
        // 0
        {
            title: 'Job Code',
            dataIndex: 'jobCode',
            key: 'jobCode',
            sorter: (a, b) => a.jobCode.props.children.localeCompare(b.jobCode.props.children),
        },
        // 1
        {
            title: 'Job Description',
            dataIndex: 'jobDescription',
            key: 'jobDescription',
            sorter: (a, b) => a.mapJobDescriptionsByJobId?.nodes?.[0]?.masterDescriptionByDescriptionId.descriptionName.localeCompare(b.mapJobDescriptionsByJobId?.nodes?.[0]?.masterDescriptionByDescriptionId.descriptionName),
        },
        // 2
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            sorter: (a, b) => a.description.props.children.localeCompare(b.description.props.children),
        },
        // 3
        {
            title: 'Received On',
            dataIndex: 'queryReceivedOn',
            key: 'queryReceivedOn',
            sorter: (a, b) => {
                // Handle empty or undefined values
                if (!a && !b) {
                    return 0; // Both values are empty or undefined
                } else if (!a) {
                    return 1; // a is empty or undefined
                } else if (!b) {
                    return -1; // b is empty or undefined
                } else {
                    return moment(b.queryReceivedOn.props.children, 'MMM D, YYYY') - moment(a.queryReceivedOn.props.children, 'MMM D, YYYY')
                }
            }
        },
        // 4
        {
            title: 'Ship Name',
            dataIndex: 'shipName',
            key: 'shipName',
            sorter: (a, b) => a.shipName.props.children.localeCompare(b.shipName.props.children),
        },
        // 5
        {
            title: 'Company',
            dataIndex: 'company',
            key: 'company',
            sorter: (a, b) => a.company.props.children.localeCompare(b.company.props.children),
        },
        // 6
        {
            title: 'Target Port',
            dataIndex: 'targetPort',
            key: 'targetPort',
            sorter: (a, b) => {
                // Handle empty or undefined values
                if (!a.targetPort.props.children && !b.targetPort.props.children) {
                    return 0; // Both values are empty or undefined
                } else if (!a.targetPort.props.children) {
                    return 1; // a is empty or undefined
                } else if (!b.targetPort.props.children) {
                    return -1; // b is empty or undefined
                } else {
                    return a.targetPort.props.children.localeCompare(b.targetPort.props.children)
                }
            },
        },
        // 7
        {
            title: 'Vessel ETA',
            dataIndex: 'vesselEta',
            key: 'vesselEta',
            sorter: (a, b) => {
                // Handle empty or undefined values
                if (!a.vesselEta.props.children && !b.vesselEta.props.children) {
                    return 0; // Both values are empty or undefined
                } else if (!a.vesselEta.props.children) {
                    return 1; // a is empty or undefined
                } else if (!b.vesselEta.props.children) {
                    return -1; // b is empty or undefined
                } else {
                    return moment(b.vesselEta.props.children, 'MMM D, YYYY') - moment(a.vesselEta.props.children, 'MMM D, YYYY')
                }
            },
        },
        // 8
        {
            title: 'Updated By',
            dataIndex: 'updatedBy',
            key: 'updatedBy',
            sorter: (a, b) => a.updatedBy.props.children.localeCompare(b.updatedBy.props.children),
        },
        // 9
        {
            title: 'Updated At',
            dataIndex: 'updatedAt',
            key: 'updatedAt',
            sorter: (a, b) => moment(b.updatedAt.props.children, 'MMM D, YYYY') - moment(a.updatedAt.props.children, 'MMM D, YYYY'),
        },
        // 10
        {
            title: 'Actions',
            dataIndex: 'action',
            key: 'action',
            fixed: 'right',
            width: 50,
        },
        // 11
        {
            title: 'Job Status',
            dataIndex: 'jobStatus',
            key: 'jobStatus',
            sorter: (a, b) => a.masterJobStatusByStatus.statusName.localeCompare(b.masterJobStatusByStatus.statusName),
        },
        // 12
        {
            title: 'Quoted On',
            dataIndex: 'quotationDate',
            key: 'quotationDate',
            sorter: (a, b) => {
                // Handle empty or undefined values
                if (!a.quotationDate.props.children && !b.quotationDate.props.children) {
                    return 0; // Both values are empty or undefined
                } else if (!a.quotationDate.props.children) {
                    return 1; // a is empty or undefined
                } else if (!b.quotationDate.props.children) {
                    return -1; // b is empty or undefined
                } else {
                    return moment(b.quotationDate.props.children, 'MMM D, YYYY') - moment(a.quotationDate.props.children, 'MMM D, YYYY')
                }
            }
        },
        // 13
        {
            title: 'Engineers',
            dataIndex: 'engineers',
            key: 'engineers',
            sorter: (a, b) => a.mapJobEngineersByJobId?.nodes?.[0]?.engineerByEngineerId.firstName.localeCompare(b.mapJobEngineersByJobId?.nodes?.[0]?.engineerByEngineerId.firstName),
        },
        // 14
        {
            title: 'Agent',
            dataIndex: 'agent',
            key: 'agent',
            sorter: (a, b) => a.agent.props.children.localeCompare(b.agent.props.children),
        },
        // 15
        {
            title: 'Spares',
            dataIndex: 'spares',
            key: 'spares',
            sorter: (a, b) => a.spares.props.children.localeCompare(b.spares.props.children),
        },
        // 16
        {
            title: 'P.O Number',
            dataIndex: 'poNumber',
            key: 'poNumber',
            sorter: (a, b) => a.poNumber.props.children.localeCompare(b.poNumber.props.children),
        },
        // 17
        {
            title: 'Completion Date',
            dataIndex: 'completionDate',
            key: 'completionDate',
            sorter: (a, b) => {
                // Handle empty or undefined values
                if (!a.completionDate.props.children && !b.completionDate.props.children) {
                    return 0; // Both values are empty or undefined
                } else if (!a.completionDate.props.children) {
                    return 1; // a is empty or undefined
                } else if (!b.completionDate.props.children) {
                    return -1; // b is empty or undefined
                } else {
                    return moment(b.completionDate.props.children, 'MMM D, YYYY') - moment(a.completionDate.props.children, 'MMM D, YYYY')
                }
            }
        },
        // 18
        {
            title: 'Next Attend Date',
            dataIndex: 'nextAttendDate',
            key: 'nextAttendDate',
            sorter: (a, b) => {
                // Handle empty or undefined values
                if (!a.nextAttendDate.props.children && !b.nextAttendDate.props.children) {
                    return 0; // Both values are empty or undefined
                } else if (!a.nextAttendDate.props.children) {
                    return 1; // a is empty or undefined
                } else if (!b.nextAttendDate.props.children) {
                    return -1; // b is empty or undefined
                } else {
                    return moment(b.nextAttendDate.props.children, 'MMM D, YYYY') - moment(a.nextAttendDate.props.children, 'MMM D, YYYY')
                }
            }
        },
        // 19
        {
            title: 'Agent Mobile',
            dataIndex: 'agentMobile',
            key: 'agentMobile',
            sorter: (a, b) => a.agent.props.children.localeCompare(b.agent.props.children),
        },
        // 20
        {
            title: 'Created By',
            dataIndex: 'createdBy',
            key: 'createdBy',
            sorter: (a, b) => a.createdBy.props.children.localeCompare(b.createdBy.props.children),
        },
        // 21
        {
            title: 'Last Modified By',
            dataIndex: 'updatedBy',
            key: 'updatedBy',
            sorter: (a, b) => a.updatedBy.props.children.localeCompare(b.updatedBy.props.children),
        }
    ]

    switch (variant) {
        case "query":
            return roleId !== 1 ? [0, 1, 3, 4, 5, 6, 7, 20, 21, 10].map(_ => defaultColumn[_]) : [0, 1, 3, 4, 5, 6, 7, 8, 9, 20, 21, 10].map(_ => defaultColumn[_]);

        case "quoted":
            return roleId !== 1 ? [0, 1, 3, 12, 4, 5, 7, 6, 20, 21, 10].map(_ => defaultColumn[_]) : [0, 1, 3, 12, 4, 5, 7, 6, 8, 9, 20, 21, 10].map(_ => defaultColumn[_]);

        case "orderConfirmed":
            return roleId !== 1 ? [0, 1, 4, 5, 13, 16, 19, 7, 6, 20, 21, 10].map(_ => defaultColumn[_]) : [0, 1, 4, 5, 13, 16, 7, 6, 8, 9, 20, 21, 10].map(_ => defaultColumn[_]);

        case "engOrderConfirmed":
            return [0, 1, 4, 7, 6, 14, 19, 15, 20, 21, 10].map(_ => defaultColumn[_]);

        case "engJobCompleted":
            return [0, 1, 4, 7, 6, 14, 19, 15, 20, 21, 10].map(_ => defaultColumn[_]);

        case "jobCompleted":
            return roleId !== 1 ? [0, 1, 3, 17, 4, 5, 16, 15, 6, 20, 21, 10].map(_ => defaultColumn[_]) : [0, 1, 3, 17, 4, 5, 16, 15, 6, 8, 9, 20, 21, 10].map(_ => defaultColumn[_]);

        case "allLiveJob":
            return roleId !== 1 ? [0, 11, 1, 3, 12, 4, 5, 13, 20, 21, 10].map(_ => defaultColumn[_]) : [0, 11, 1, 3, 12, 4, 5, 13, 8, 9, 20, 21, 10].map(_ => defaultColumn[_]);

        case "alarams":
            return roleId !== 1 ? [0, 1, 3, 4, 5, 6, 7, 20, 21, 10].map(_ => defaultColumn[_]) : [0, 1, 3, 4, 5, 6, 7, 8, 9, 20, 21, 10].map(_ => defaultColumn[_]);

        case "cancelledJobs":
            return roleId !== 1 ? [0, 1, 3, 12, 4, 5, 13, 20, 21, 10].map(_ => defaultColumn[_]) : [0, 1, 3, 12, 4, 5, 13, 8, 9, 20, 21, 10].map(_ => defaultColumn[_]);

        case "jobHistory":
            return roleId !== 1 ? [0, 1, 3, 12, 4, 5, 13, 18, 20, 21, 10].map(_ => defaultColumn[_]) : [0, 1, 3, 12, 4, 5, 13, 18, 8, 9, 20, 21, 10].map(_ => defaultColumn[_]);


        default:
            return defaultColumn;
    }
};

export const allJobStatusColor = ['', 'processing', 'magenta', 'warning', 'success'];

export const dataSource = (handleView, jobs = [], handleEdit) => jobs?.map((job, key) => {
    const {
        id, jobCode, mapJobDescriptionsByJobId, description, queryReceivedOn, shipName,
        companyByCompanyId, targetPort, vesselEta, updatedAt, userProfileByUpdatedBy, quotationDate,
        mapJobEngineersByJobId, agentByAgentId, agentId, mapJobSparesByJobId, poNumber, completionDate,
        masterJobStatusByStatus, status, nextAttendDate, userProfileByCreatedBy, spares
    } = job;

    return {
        ...job,
        key: id,
        jobCode: <p className="text-black font-normal dark:text-white60 text-[15px]">{jobCode}</p>,
        jobStatus: <div className="text-black font-normal dark:text-white60 text-[15px]">{<Tag color={allJobStatusColor[status]} >{masterJobStatusByStatus.statusName}</Tag>}</div>,
        jobDescription: <div className=" flex flex-wrap gap-2 max-w-[250px] text-black font-normal dark:text-white60 text-[15px]">{mapJobDescriptionsByJobId?.nodes?.map(_ => <Tag className='w-full' style={{textWrap:"wrap"}}>{_.masterDescriptionByDescriptionId.descriptionName}</Tag>) ?? "-"}</div>,
        spares: <div className=" flex flex-wrap gap-2 max-w-[120px] text-black font-normal dark:text-white60 text-[15px]">
            {spares ? spares : `${mapJobSparesByJobId?.nodes?.map(_ => _?.masterSpareBySpareId?.name ?? "")?.join(",") ?? "-"}`}
        </div>,
        engineers: <div className=" flex flex-wrap gap-2 max-w-[120px] text-black font-normal dark:text-white60 text-[15px]">{mapJobEngineersByJobId?.nodes?.map(_ => <Tag>{_.engineerByEngineerId.firstName}</Tag>) ?? "-"}</div>,
        description: <p className="max-w-[120px] whitespace-normal text-black font-normal dark:text-white60 text-[15px]">{description}</p>,
        poNumber: <p className="max-w-[120px] whitespace-normal text-black font-normal dark:text-white60 text-[15px]">{poNumber}</p>,
        queryReceivedOn: <p className="text-black font-normal dark:text-white60 text-[15px]">{queryReceivedOn ? moment.utc(queryReceivedOn).local().format("ll").toString() : ""}</p>,
        completionDate: <p className="text-black font-normal dark:text-white60 text-[15px]">{completionDate ? moment.utc(completionDate).local().format("ll").toString() : ""}</p>,
        shipName: <p className="max-w-[120px] whitespace-normal text-black font-normal dark:text-white60 text-[15px]">{shipName}</p>,
        company: <p className="max-w-[300px] whitespace-normal text-black font-normal dark:text-white60 text-[15px]">{companyByCompanyId.companyName}</p>,
        agent: <p className="max-w-[120px] whitespace-normal text-black font-normal dark:text-white60 text-[15px]">{agentId ? `${agentByAgentId.firstName}` : "-"}</p>,
        agentMobile: <p className="max-w-[120px] whitespace-normal text-black font-normal dark:text-white60 text-[15px]">{agentId ? `${agentByAgentId.mobile}` : "-"}</p>,
        targetPort: <p className="max-w-[120px] whitespace-normal text-black font-normal dark:text-white60 text-[15px]">{targetPort}</p>,
        vesselEta: <p className="text-black font-normal dark:text-white60 text-[15px]">{vesselEta ? moment.utc(vesselEta).local().format("ll").toString() : ""}</p>,
        updatedBy: <p className="text-black font-normal dark:text-white60 text-[15px]">{userProfileByUpdatedBy.firstName}</p>,
        updatedAt: <p className="text-black font-normal dark:text-white60 text-[15px]">{moment.utc(updatedAt).local().format("ll").toString()}</p>,
        quotationDate: <p className="text-black font-normal dark:text-white60 text-[15px]">{quotationDate ? moment.utc(quotationDate).local().format("ll").toString() : ""}</p>,
        nextAttendDate: <p className="text-black font-normal dark:text-white60 text-[15px]">{nextAttendDate ? moment.utc(nextAttendDate).local().format("ll").toString() : ""}</p>,
        action: (
            <div className=" bg-white flex justify-end items-center gap-2 w-full ">
                <Tooltip title={"Edit Job"}>
                    <UilEdit to="#" onClick={() => handleEdit(job)} className="w-4 cursor-pointer text-light-extra dark:text-white60" />
                </Tooltip>
                <Tooltip title={"View Job"}>
                    <UilView to="#" onClick={() => handleView(job)} className="w-4 cursor-pointer text-light-extra dark:text-white60" />
                </Tooltip>
            </div>
        ),
        vesselETA: vesselEta,
        createdBy: <p className="max-w-[120px] whitespace-normal text-black font-normal dark:text-white60 text-[15px]">{userProfileByCreatedBy ? `${userProfileByCreatedBy.firstName}` : "-"}</p>,
        updatedBy: <p className="max-w-[120px] whitespace-normal text-black font-normal dark:text-white60 text-[15px]">{userProfileByUpdatedBy ? `${userProfileByUpdatedBy.firstName}` : "-"}</p>,
    };
});